function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#1A87C7;}\n\t.st1{fill:#BDEDF8;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  className: "st0",
  d: "M651.68,216.2"
}), React.createElement("path", {
  className: "st0",
  d: "M663.88,233c-0.8-0.8-1.4-1.8-1.8-3.2C662.88,231.6,663.48,232.4,663.88,233z"
}), React.createElement("path", {
  className: "st0",
  d: "M664.68,233.6c-0.2-0.2-0.4-0.4-0.6-0.6C664.08,233.4,664.28,233.6,664.68,233.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M509.48,314.8c24-13.8,47.2-20.6,68.2-21l-52-30.2l0,0l-25.6-14.2c-9.4-4.2-19.4-5.8-28.8-5.8 c-25.2,0-49.2,11.2-63.4,19.6c-69.2,40-127.8,128.2-143,214.2c-0.4,4.4-1,8.4-1.6,12.8l96.4,55.6 C372.08,455.4,435.28,357.4,509.48,314.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M625.28,307.4l10.4,6c8-7,16.6-13.2,25-18.2c15-8.6,29.6-13.2,43.2-14.4l-33.2-19.2l-49.8-28.2 c-4.8-2-11-3.2-17.2-3.4c-25.8-0.6-49.6,15-64.6,27.2l78.6,45.4C620.08,304.2,622.68,305.6,625.28,307.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M353.48,556.6l-96.6-55.8l-1.2,1c-39.2,31.4-70.8,84.2-79.6,134.4c-2.6,15.4-7.4,53.8,11.6,78.2 c3.6,5,7.8,8.8,13.6,12.4l76.2,44c-5.6-12.4-8.6-27.2-8.6-44.4C268.88,667.4,304.08,597.6,353.48,556.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M738.28,286.8c12.2,6.2,21.6,16.2,28,30.2c8.8-3.4,17.4-5,25.6-5.8l-82.8-47.4c-4.6-1.8-10-2.8-15.6-3 l44.4,25.6C737.88,286.6,737.88,286.6,738.28,286.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M840.08,327.4c0.6,0.6,1.4,1.4,2,2C841.48,328.6,840.88,328,840.08,327.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M832.48,321c1.2,0.8,2.2,1.6,3.2,2.4C834.88,322.4,833.68,321.6,832.48,321z"
}), React.createElement("path", {
  className: "st0",
  d: "M283.48,781.4l-85.4-49.6c-6.2-3.8-11-8-15.8-13.8c-16.8-22.4-17.2-56.4-12.6-83 c9.4-51,41.4-105.6,81.8-138.2l0.2-0.2c-1.4-2-2-4.4-0.8-6.6s3.8-2.8,6.2-2.6c0.6-3.8,1-7.6,1.8-11.4 c14.2-82.8,71.8-175.8,145.6-218.6c28.8-16.8,66-28,98-14l3.6,1.6l16.8,9.8l0,0c1.6-3,5.2-4,8.4-2.2l2,1.2 c19.8-16.2,44.8-30.6,70.4-30.2c6.8,0.2,13.6,1.4,20,4l3.2,1.4l41.4,24.2l0,0c2-3,5.8-4,8.4-2.2l6.6,3.8c9.6-1,19.4-0.2,28,3.2 l3.6,1.6l88.6,51.2c9.6,0.6,18.4,3.4,26.2,8c-1.2-0.8-2.4-1.6-3.8-2.4l-108.4-62.6l-3.6-1.6c-10.4-4.2-23-5.4-36.2-3l-3.2,0.6 l-45-26.2l-3.2-1.4c-6.8-2.8-14.6-4.2-22.6-4.4c-0.6,0-0.6,0-1,0c-30.4,0-58.6,19.4-75,33l-18.8-11l-3.6-1.6 c-39.4-17.2-82.2,1.6-103.8,14.4c-71.8,41.8-133,133.4-148.8,222.8c-0.6,5-1.6,9.8-2,14.8l-2.6,2.2c-41.4,33.2-74.4,89-83.8,141.8 c-3.2,17-7.8,59.4,13.6,87.8c4.8,6.2,10,11.2,17.2,15.4l108,62.4C295.28,795.2,288.48,789,283.48,781.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M852.48,344.8c0,0.2,0.2,0.2,0.2,0.2S852.68,344.8,852.48,344.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M857.08,354.8L857.08,354.8L857.08,354.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M859.88,366c0,0.2,0,0.4,0.2,0.4C860.08,366,860.08,366,859.88,366z"
}), React.createElement("path", {
  className: "st0",
  d: "M847.08,335.4c0.2,0.4,0.6,0.8,0.8,1.2C847.48,336,847.48,335.6,847.08,335.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M861.48,377.2c0,0.4,0.2,1,0.2,1.4C861.68,378,861.68,377.8,861.48,377.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M711.08,258c-8.6-3.6-18.4-4.2-28-3.2l10.2,6c5.6,0.2,11,1.2,15.6,3l82.8,47.4c4-0.4,8-0.6,11.8-0.4 l-88.6-51.2L711.08,258z"
}), React.createElement("path", {
  className: "st0",
  d: "M262.88,490c0.6-4.2,1.2-8.4,1.6-12.8c15.2-86,73.8-174.2,143-214.2c14.2-8.4,38.2-19.6,63.4-19.6 c9.4,0,19.4,1.6,28.8,5.8l25.6,14.2c-3-1.8-4-5.4-2.6-8.4l-16.8-9.8l-3.6-1.6c-32-14-69.2-2.8-98,14 c-73.8,42.8-131.6,135.6-145.6,218.6c-0.8,3.8-1.2,7.6-1.8,11.4c0.8,0.2,1.6-0.2,2.2,0.4L262.88,490z"
}), React.createElement("path", {
  className: "st0",
  d: "M201.08,726.8c-5.8-3.4-10-7.4-13.6-12.4c-18.8-24.4-14.2-62.8-11.6-78.2c9-50.2,40.4-103,79.6-134.4l1.2-1 l-3.8-2.2c-0.6-0.4-0.8-1.2-1.4-2l-0.2,0.2c-40.4,32.6-72.2,87.2-81.8,138.2c-4.8,26.6-4.2,60.6,12.6,83 c4.8,5.8,9.4,10.2,15.8,13.8l85.4,49.6c-2.2-3.4-4.4-6.8-6-10.6L201.08,726.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M603.68,230.4c6.2,0,12.6,1.4,17.2,3.4l49.8,28.2c-3.2-1.8-4.2-5.4-2.6-8.4l-41.4-24.2l-3.2-1.4 c-6.2-2.6-13-3.8-20-4c-25.6-0.4-50.6,14-70.4,30.2l5.6,3.2C553.88,245.4,577.68,229.8,603.68,230.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M860.08,366.2c0.8,3.4,1.2,7.2,1.6,10.8C861.28,373.4,860.88,369.8,860.08,366.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M847.68,336.6c1.8,2.6,3.4,5.4,4.8,8.2C851.28,341.6,849.68,339.2,847.68,336.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M831.08,319.8c-0.4-0.2-1-0.4-1.4-0.6c1,0.6,2,1.2,3,1.8C832.08,320.4,831.48,320,831.08,319.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M862.48,391.6c0-4.4-0.2-8.8-0.6-12.8C862.28,382.8,862.48,387.2,862.48,391.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M842.28,329.2c1.8,1.8,3.4,3.8,4.8,6C845.48,333,843.68,331,842.28,329.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M857.08,354.8c1.2,3.4,2.2,7,3,10.8C859.08,362.2,858.28,358.6,857.08,354.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M835.88,323.4c1.6,1.2,3,2.4,4.4,3.8C838.68,326,837.48,324.4,835.88,323.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M852.68,344.8c1.6,3.2,3,6.4,4.2,10C855.88,351.6,854.28,348,852.68,344.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M738.28,286.8c2.8,1.8,3.8,5.2,2.2,8c0,0.2-0.2,0.2-0.2,0.2c10,6.6,18,16.6,22.8,30.2 c13.8-6.2,26.8-9,38.4-8.4l-9.6-5.6c-8.2,0.8-16.8,2.4-25.6,5.8C759.88,303,750.08,293,738.28,286.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M509.48,314.8c-74.2,42.6-137.2,140.6-150,231l5.8,3.2c11.8-88.4,73.2-186.2,147.4-229 c28.2-16.4,54.6-22.2,77.4-19.2l-12.2-7C556.28,294.2,533.28,301,509.48,314.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M635.48,313.6l2.6,1.4c1,0.6,1.6,1.6,2.2,2.6c7.6-6.4,15.4-12.2,23.6-17c18.2-10.4,35-14.8,49.8-14l-9.8-5.6 c-13.8,1.2-28.4,5.8-43.2,14.4C652.28,300.4,643.68,306.2,635.48,313.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M359.08,560l-5.6-3.2c-49.2,40.8-84.8,110.6-84.8,169.8c0,17,3,32,8.6,44.4l10.4,6 c-8.2-12.4-12.8-29.4-12.8-50.4C274.88,668,311.48,598.8,359.08,560z"
}), React.createElement("path", {
  className: "st0",
  d: "M617.48,303l7.8,4.6C622.68,305.6,620.08,304.2,617.48,303z"
}), React.createElement("path", {
  className: "st0",
  d: "M861.48,377.2c-0.4-3.8-1-7.4-1.6-10.8c0-0.2,0-0.4-0.2-0.4c-0.8-3.8-1.8-7.4-3-10.8l0,0 c-1.2-3.6-2.6-6.8-4.2-10c0-0.2-0.2-0.2-0.2-0.2c-1.4-3-3-5.6-4.8-8.2c-0.2-0.4-0.6-0.8-0.8-1.2c-1.6-2.2-3.2-4.2-4.8-6 c-0.6-0.8-1.4-1.4-2-2c-1.4-1.4-2.8-2.6-4.4-3.8c-1-0.8-2.2-1.8-3.2-2.4s-2-1.2-3-1.8c-7.8-4.8-16.6-7.4-26.2-8l19.2,11.2 c0.8,0.4,1.4,0.8,2,1.2c1.6,1,3.4,1.8,4.8,3c0.6,0.4,1.2,1,1.6,1.4c1.6,1.2,3.2,2.6,4.8,4.2c0.4,0.4,1,1,1.4,1.6 c1.4,1.6,3,3.4,4.2,5.2c0.4,0.6,0.8,1.2,1.2,1.8c1.2,2,2.4,4,3.6,6c0.4,0.6,0.8,1.4,1,2.2c1,2.2,2,4.4,2.8,6.8 c0.4,0.8,0.6,1.6,0.8,2.6c0.8,2.4,1.4,4.8,2,7.4c0.2,1,0.4,2,0.6,3c0.6,2.6,1,5.4,1.2,8.2c0.2,1,0.4,2,0.4,3 c0.4,3.8,0.6,7.8,0.6,12c0,66.8-46.6,148-104.8,181.2l-370.8,213.6c-22.2,12.8-42.8,16.6-59.8,12.8c-5-1.2-9.8-3-14.2-5.4h-0.4 l-22-12.8c5.2,7.6,11.6,13.8,19.4,18.2c9,5.2,19.4,7.8,30.4,7.8c15.2,0,32.4-5,49.8-15.2l371.6-214.4c59.8-34.2,108-118,108-186.6 c0-4.4-0.2-8.8-0.6-12.8C861.68,378,861.68,377.8,861.48,377.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M287.68,776.8l-10.4-6c1.8,3.8,3.8,7.4,6,10.6l22,12.8h0.4C298.88,790.2,292.68,784.4,287.68,776.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M836.08,331.8c0.4,0.4,1,1,1.4,1.6C837.08,333,836.48,332.4,836.08,331.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M829.68,326.2c0.6,0.4,1.2,1,1.6,1.4C830.88,327.4,830.08,326.6,829.68,326.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M850.28,355.4c0.4,0.8,0.6,1.6,0.8,2.6C851.08,356.8,850.48,356,850.28,355.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M841.68,338.6c0.4,0.6,0.8,1.2,1.2,1.8C842.48,339.8,842.28,339.2,841.68,338.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M853.28,365c0.2,1,0.4,2,0.6,3C853.68,367.2,853.48,366,853.28,365z"
}), React.createElement("path", {
  className: "st0",
  d: "M846.48,346.6c0.4,0.6,0.8,1.4,1,2.2C847.28,348,846.68,347.2,846.48,346.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M855.08,376.2c0.2,1,0.4,2,0.4,3C855.48,378.4,855.28,377.4,855.08,376.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M791.48,311.2l9.6,5.6c8.6,0.4,16.4,2.6,23.4,6.4c-0.8-0.4-1.4-1-2-1.2l-19.2-11.2 C799.68,310.6,795.48,311,791.48,311.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M319.88,800c17,4,37.6,0.2,59.8-12.8C357.68,800,337.08,803.8,319.88,800z"
}), React.createElement("path", {
  className: "st0",
  d: "M844.08,356.6c1.6,4.2,3,8.6,3.8,13.4C847.08,365.4,845.88,361,844.08,356.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M836.28,341.8c2.4,3.2,4.4,6.8,6.2,10.6C840.48,348.6,838.68,345,836.28,341.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M848.48,373.6c0.8,5.6,1.4,11.6,1.4,18C850.08,385,849.48,379.2,848.48,373.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M281.48,726.4c0-57.6,37.2-129,86.4-166c0.2-0.2,0.4-0.4,0.6-0.6c-1.4,1.2-2.8,2-4.4,2c-1,0-2.2-0.2-3.2-0.8 l-1.8-1c-47.8,38.8-84.2,108-84.2,166.6c0,20.8,4.6,37.8,12.8,50.4l20.6,12C291.08,778.6,281.48,756.4,281.48,726.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M331.08,795.2c-2.6,0-5-0.4-7.6-0.8C325.88,795,328.48,795.2,331.08,795.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M824.68,330.4c3.6,2.4,6.8,5.4,9.6,8.8C831.28,335.6,828.28,332.8,824.68,330.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M762.88,325.4c-4.8-13.6-12.8-23.6-22.8-30.2c-1.6,1.8-3.4,2.8-5.4,2.8c-1,0-2-0.2-2.6-0.8l-18.2-10.6 c-14.8-0.8-31.8,3.6-49.8,14c-8.2,4.8-16,10.6-23.6,17c1,1.8,1.6,3.8,0.4,5.8c-1,2-3.2,3-5.2,3c-1,0-2.2-0.2-3.2-0.8l-42.6-24.6 c-22.6-3-49,2.8-77.4,19.2c-74.2,42.8-135.6,140.4-147.4,229l2.2,1.2c2.8,1.4,3.6,4.6,2.8,7.4c0.2-0.4,0.4-1,0.4-1.4 c9.4-89.2,71.8-188.6,145.2-230.8c22-13,44-19.4,63.4-19.4c20,0,37.2,7,50.8,20.8c2,2.4,5.8,2.6,8.4,0.4 c9.4-8.6,18.8-15.8,28.8-21.4c22.6-13,44-16.6,60.8-10.4c13.6,5,23.6,16,29.4,31.8c0.6,1.6,1.6,3,3.2,3.6s3.6,0.6,5.2,0 c22.2-10.2,43-10.4,58-1c-1.2-0.8-2.4-1.6-3.6-2.2l-18.6-10.8C789.68,316.2,776.68,319,762.88,325.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M323.48,794.2c-3.6-0.6-6.8-1.8-10.2-3.2C316.48,792.6,319.68,793.8,323.48,794.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M851.28,358c0.8,2.4,1.4,4.8,2,7.4C852.48,362.8,852.08,360,851.28,358z"
}), React.createElement("path", {
  className: "st0",
  d: "M831.28,327.8c1.6,1.2,3.2,2.6,4.8,4.2C834.68,330.4,832.88,329,831.28,327.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M837.48,333.6c1.4,1.6,3,3.4,4.2,5.2C840.28,336.6,838.88,335,837.48,333.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M824.88,323.4c1.6,1,3.4,1.8,4.8,3C827.88,325,826.28,324.2,824.88,323.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M305.88,794.2c4.4,2.6,9.2,4.2,14.2,5.4C314.88,798.8,310.28,796.8,305.88,794.2L305.88,794.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M853.88,368c0.6,2.6,1,5.4,1.2,8.2C854.88,373.6,854.28,370.6,853.88,368z"
}), React.createElement("path", {
  className: "st0",
  d: "M847.48,348.6c1,2.2,2,4.4,2.8,6.8C849.68,353,848.68,350.6,847.48,348.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M855.48,379.2c0.4,3.8,0.6,7.8,0.6,12C856.28,387.4,856.08,383.4,855.48,379.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M842.88,340.4c1.2,2,2.4,4,3.6,6C845.28,344.2,844.08,342.4,842.88,340.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M820.08,327.4c1.2,0.6,2.4,1.4,3.6,2.2c0.2,0.2,0.4,0.2,0.6,0.2s0.2,0.2,0.4,0.4c3.6,2.4,6.8,5.2,9.6,8.8 c0.8,0.8,1.4,1.8,2,2.6c2.4,3.2,4.4,6.6,6.2,10.6c0.6,1.4,1.2,3,1.8,4.4c1.6,4.2,2.8,8.6,3.8,13.4c0.2,1,0.4,2.2,0.4,3.2 c0.8,5.6,1.4,11.6,1.4,18c0,64.8-45.6,143.6-101.6,175.8l-371.4,214.6c-16.4,9.4-31.8,14-45.6,13.4c-2.6,0-5-0.4-7.6-0.8 c-0.2,0-0.2,0-0.4,0c-3.6-0.6-7-1.8-10.2-3.2c-1.6-0.6-3-1.2-4.6-2l-0.2-0.2l-20.6-12c4.8,7.4,11,13.4,18,17.4h0.2 c4.4,2.6,9,4.2,14,5.4c17,3.8,37.6,0.2,59.8-12.8l371.6-214.4c58.2-33.4,104.8-114.4,104.8-181.2c0-4.2-0.2-8.2-0.6-12 c0-1-0.2-2-0.4-3c-0.4-2.8-0.8-5.6-1.2-8.2c-0.2-1-0.4-2-0.6-3c-0.6-2.6-1.2-5-2-7.4c-0.2-0.8-0.6-1.6-0.8-2.6 c-0.8-2.4-1.8-4.6-2.8-6.8c-0.4-0.8-0.6-1.4-1-2.2c-1.2-2.2-2.4-4.2-3.6-6c-0.4-0.6-0.8-1.2-1.2-1.8c-1.4-1.8-2.8-3.6-4.2-5.2 c-0.4-0.6-1-1-1.4-1.6c-1.6-1.6-3.2-2.8-4.8-4.2c-0.6-0.4-1.2-1-1.6-1.4c-1.6-1.2-3.2-2-4.8-3c-7-3.8-14.8-6-23.4-6.4 L820.08,327.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M358.48,552.6c0.2-2.2,0.6-4.4,1-6.6l-96.4-55.6c-0.2,1.2-0.4,2.6-0.4,3.8c0,1.6-1,3.2-2.2,4.2l-3.4,2.6 l96.6,55.8C355.28,555.2,356.68,553.8,358.48,552.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M257.08,487.8c-2.4-0.4-5,0.4-6.2,2.6c-1.2,2.2-0.6,4.6,0.8,6.6l4.4-3.4 C256.48,491.6,256.68,489.8,257.08,487.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M257.08,501l3.4-2.6c1-1,2.2-2.6,2.2-4.2c0.2-1.4,0.4-2.6,0.4-3.8l-3.6-2c-0.6-0.4-1.4-0.2-2.2-0.4 c-0.2,1.8-0.6,3.8-0.8,5.6l-4.4,3.4c0.4,0.6,0.6,1.4,1.4,2L257.08,501z"
}), React.createElement("path", {
  className: "st0",
  d: "M369.88,558.8c0.2-0.2,0-0.6,0-1c-0.4,0.8-0.8,1.6-1.4,2.2C369.08,559.6,369.68,559.2,369.88,558.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M358.48,552.6c-1.6,1.2-3.2,3-4.8,4.2l5.6,3.2c1.6-1.4,3.2-3,5-4.2c0.2-2.2,0.6-4.4,1-6.6l-5.8-3.2 C359.08,548,358.48,550.2,358.48,552.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M359.08,560l1.8,1c1,0.6,2,0.8,3.2,0.8c1.6,0,3-0.8,4.4-2c0.8-0.6,1.2-1.4,1.4-2.2c1-2.8,0.2-6-2.8-7.4 l-2.2-1.2c-0.2,2.2-0.6,4.4-1,6.6C362.28,556.8,360.88,558.8,359.08,560z"
}), React.createElement("path", {
  className: "st0",
  d: "M577.48,294c14.6-0.2,28,3,39.8,9l-78.6-45.4c-2.4,2-4.6,3.8-6.6,5.6c-2,1.8-4.8,2-6.8,0.6l0,0l0,0 L577.48,294z"
}), React.createElement("path", {
  className: "st0",
  d: "M635.48,313.6l-10.4-6c3.2,2.2,6.4,4.2,9.2,6.8C635.08,314,635.08,313.6,635.48,313.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M533.28,254.2l-2-1.2c-3.2-1.6-6.8-0.8-8.4,2.2l0,0l5.2,3C529.88,256.8,531.48,255.4,533.28,254.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M525.28,263.6L525.28,263.6c2.2,1.4,4.8,1,6.8-0.6c2-1.8,4.2-3.6,6.6-5.6l-5.6-3.2c-1.8,1.4-3.4,2.8-5,4.2 l-5.2-3C521.28,258.4,522.48,261.8,525.28,263.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M635.48,313.6c-0.4,0.4-0.8,0.6-1.2,0.8c-2.8-2.6-6-4.8-9.2-6.8l-7.8-4.6c-12-6.2-25.4-9.2-39.8-9l12.2,7 c17.2,2.2,32.4,9.6,44.2,21.8c2-1.8,4.2-3.4,6.4-5.2c-0.6-1-1-2-2.2-2.6L635.48,313.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M589.88,301l42.6,24.6c1,0.6,2,0.8,3.2,0.8c2.2,0,4.2-1.2,5.2-3c1-2,0.6-4-0.4-5.8c-2.2,1.8-4.2,3.4-6.4,5.2 C622.28,310.4,607.08,303,589.88,301z"
}), React.createElement("path", {
  className: "st0",
  d: "M675.08,262.4c-1.6,0.4-3.2,0-4.2-0.6l33.2,19.2c10-0.8,19.4-0.2,28,3c2.2,0.8,4.2,2,6.2,3 c-0.2-0.2-0.2-0.4-0.4-0.4l-44.4-25.6c-4.4-0.2-9-0.2-13.6,0.6L675.08,262.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M678.68,255.4c1.4-0.2,3-0.4,4.4-0.4l-6.6-3.8c-2.6-1.8-6.2-0.8-8.4,2.2l0,0l5.2,3L678.68,255.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M670.48,261.6c1,0.8,2.6,1,4.2,0.6l4.8-1c4.6-0.8,9.2-0.8,13.6-0.6l-10.2-6c-1.4,0.2-3,0.2-4.4,0.4l-5.2,1 l-5.2-3C666.48,256.2,667.48,260,670.48,261.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M740.08,295c0-0.2,0.2-0.2,0.2-0.2c1.4-2.8,0.4-6.2-2.2-8c-2-1-4-2.2-6.2-3c-8.6-3.2-18.2-3.8-28-3l9.8,5.6 C723.68,287.2,732.48,290,740.08,295z"
}), React.createElement("path", {
  className: "st0",
  d: "M732.08,297.2c0.6,0.6,1.6,0.8,2.6,0.8c2,0,4-1,5.4-2.8c-7.6-5-16.4-8-26.4-8.4L732.08,297.2z"
})), React.createElement("g", null, React.createElement("polygon", {
  className: "st0",
  points: "613.68,276.2 613.68,276.2 613.68,276  "
}), React.createElement("path", {
  className: "st0",
  d: "M600.48,393.6l-0.8-0.4C600.08,393,600.28,393.4,600.48,393.6L600.48,393.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M537.48,560.2c-2.2-1.6-3.2-2.6-3.6-4.4l-3.6-9.8l-15.4,52l44.2-25.6L537.48,560.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M582.68,458c1,0.8,1.8,2,2.4,3.4c1.6,5.4,3.2,10.8,5.2,16l18.4,45.4c1,2.8,0,6-2.6,7.6l-12,7l13,7.4l36-20.8 l-2.4-5.8l-24.2-14c-2.2-1.2-3.2-3.2-3.2-5.4v-47.2l-18.8-46l-26.2,15.2c-0.8,0.4-1.8,1.8-2.6,3.2c-0.2,0.4-0.4,0.8-0.6,1.6 l-4.4,14.6l-1.4,4.8l23,13C582.68,458,582.68,458,582.68,458z"
}), React.createElement("path", {
  className: "st1",
  d: "M487.68,690.6l24.6-14.4c1-0.6,2.6-2.6,3.2-4.4l19.8-71l-25.8,14.8L487.68,690.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M621.08,554.2l18.4,48.8l25.2-14.6c1.6-1,3.2-3.6,3.2-5.4c0-0.2,0-0.2,0-0.2l-19.4-47.2l-28.6,16.6 C620.08,552.6,620.48,553.6,621.08,554.2z"
}), React.createElement("polygon", {
  className: "st1",
  points: "565.28,576.4 559.08,572.6 515.08,598 512.48,606.6  "
}), React.createElement("polygon", {
  className: "st1",
  points: "645.88,530 643.48,524 607.48,545 613.68,548.6  "
}), React.createElement("path", {
  className: "st1",
  d: "M618.68,551.4c0.2,0.2,0.6,0.4,0.8,0.6l28.6-16.6l-2.4-5.8l-32.2,18.6l4.8,2.8 C618.48,551.4,618.68,551.4,618.68,551.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M539.08,593l27.8-16l-1.6-1l-53,30.6l-1.4,4.8l-1.2,3.8l25.8-14.8l1-3.8 C537.28,595.2,538.28,593.8,539.08,593z"
}), React.createElement("polygon", {
  className: "st1",
  points: "633.48,499.8 625.88,481.6 625.48,495.4  "
}), React.createElement("path", {
  className: "st1",
  d: "M616.68,504.2l24.2,14l-3.8-9.4l-17.2-10v-32l-6.2-15.4v47.2C613.68,501,614.68,503,616.68,504.2z"
}), React.createElement("polygon", {
  className: "st1",
  points: "625.48,495.4 625.88,481.6 620.08,466.8 620.08,499 637.28,509 633.48,499.8  "
}), React.createElement("path", {
  className: "st1",
  d: "M540.88,539l4.2,11l4.2,2.4c0-0.4-0.2-0.8,0-1.4l6.2-23.6c5.8-20.6,11.6-41,16.6-61.4l-16-9.2l-22.4,76.4 l4.4,2.4C539.08,536.4,540.08,537.6,540.88,539z"
}), React.createElement("polygon", {
  className: "st1",
  points: "582.08,544.4 558.68,557.8 571.48,565.4 595.08,551.8  "
}), React.createElement("polygon", {
  className: "st1",
  points: "601.28,555.4 595.08,551.8 571.48,565.4 577.48,569  "
}), React.createElement("polygon", {
  className: "st1",
  points: "602.68,556.4 601.28,555.4 577.48,569 579.08,570.2  "
}), React.createElement("path", {
  className: "st1",
  d: "M579.68,457.2c1.4,0,2.4,0.4,3.4,1c0,0,0-0.2-0.2-0.2l-23-13l-1.8,6l16.4,9.4 C575.28,458.6,577.28,457.2,579.68,457.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M566.08,424c-0.2,0.4-0.6,0.8-0.6,1.2l-4.4,14.8l4.4-14.6C565.48,424.8,565.88,424.4,566.08,424z"
}), React.createElement("polygon", {
  className: "st1",
  points: "601.08,548.6 607.48,545 594.08,537.6 587.88,541.2  "
}), React.createElement("path", {
  className: "st1",
  d: "M515.08,598l15.4-52l3.6,9.8c0.6,1.8,1.6,2.8,3.6,4.4l21.4,12.4l6.2-3.6l-24.6-14.2c-1-0.6-1-0.8-1.6-1.8 l-4.2-12l-3-1.8L515.08,598L515.08,598z"
}), React.createElement("polygon", {
  className: "st1",
  points: "512.48,606.6 514.88,598 514.88,598  "
}), React.createElement("polygon", {
  className: "st1",
  points: "607.48,552.2 613.68,548.6 607.48,545 601.08,548.6  "
}), React.createElement("polygon", {
  className: "st1",
  points: "565.28,576.4 571.48,572.6 565.28,569 559.08,572.6  "
}), React.createElement("polygon", {
  className: "st1",
  points: "510.88,611.6 512.48,606.6 512.48,606.6  "
}), React.createElement("polygon", {
  className: "st1",
  points: "573.28,573.6 571.48,572.6 565.28,576.4 567.08,577.2  "
}), React.createElement("path", {
  className: "st1",
  d: "M612.08,551.2c1.6-0.8,3.6-1,5.2-0.4c0.4,0.2,1,0.6,1.4,0.8c-0.2-0.2-0.2-0.4-0.4-0.4l-4.8-2.8l-6.2,3.6 l1.6,1L612.08,551.2z"
}), React.createElement("polygon", {
  className: "st1",
  points: "601.08,548.6 587.88,541.2 582.08,544.4 595.08,551.8  "
}), React.createElement("path", {
  className: "st1",
  d: "M535.08,541.4l4.2,12c0.6,1,0.6,1.2,1.6,1.8l24.6,14.2l6.2-3.6l-13-7.6l-0.4,0.2c-1,0.6-2,0.8-3.2,0.8 c-1,0-2.6-0.4-3.6-1.4c-1.8-1.2-2.2-3.2-2-5.2l-4.2-2.4l-4.2-11c-0.6-1.4-1.6-2.4-2.6-3.2l-4.4-2.4l-1.8,6.2L535.08,541.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M572.28,466c0.4-1.4,0.8-3,1.2-4.4c0.2-0.6,0.8-1,1-1.4l-16.4-9.4l-1.8,6.2L572.28,466z"
}), React.createElement("polygon", {
  className: "st1",
  points: "577.48,569 571.48,565.4 565.28,569 571.48,572.6  "
}), React.createElement("polygon", {
  className: "st1",
  points: "601.28,555.4 607.48,552.2 601.08,548.6 595.08,551.8  "
}), React.createElement("polygon", {
  className: "st1",
  points: "602.68,556.4 608.88,552.8 607.48,552.2 601.28,555.4  "
}), React.createElement("polygon", {
  className: "st1",
  points: "579.08,570.2 577.48,569 571.48,572.6 573.28,573.6  "
}), React.createElement("path", {
  className: "st0",
  d: "M603.28,401.2c-0.4,1.2-1.4,1.8-2.4,2.4l16.2,39.6l5.2-3l-17.4-42.2c-0.8-2.2-2.2-3.6-4-4.6 C603.68,395,604.68,398.6,603.28,401.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M599.48,393L599.48,393l0.2,0.2C599.68,393,599.68,393,599.48,393z"
}), React.createElement("path", {
  className: "st0",
  d: "M547.48,602.6l31.8-18.2l-6.2-3.6l-30.8,17.8l-20.4,74.6c-1,3.4-3.6,6.8-6.2,8.4l-27.4,16 c0.2,0.8,0.4,1.4,0.4,2.2l37.6-21.6c0.4-1,1.2-2,1.4-3.2L547.48,602.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M479.68,704c0.2,0.2,0.4,0.2,0.6,0.4l0.2-0.2C479.88,704.2,479.68,704.2,479.68,704z"
}), React.createElement("path", {
  className: "st0",
  d: "M633.68,615.4c0.2,0,0.2,0.2,0.4,0.2l0.2-0.2C634.08,615.4,633.68,615.4,633.68,615.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M673.48,580.4c0,0.6,0.6,1.6,0.6,2.6c0,4-3.2,8.8-6.2,10.6l-25.6,14.8c0.4,0.8,0.4,1.4,0.4,2.4l36-20.8 c1-2.2,1.8-4.8,1.8-7c0-1.8-0.6-3.6-1-5l-20.2-48.6l-5.4,3L673.48,580.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M642.08,613.8c-1.8,2.4-4.8,2.6-7.6,1.8l-0.2,0.2c0.2,0,0.2,0.2,0.4,0.2c2.6,1,5.8,0.6,9-1.2l27.2-15.6 c3.2-1.8,6-5.2,7.6-9l-36,20.8C642.48,611.8,642.48,612.8,642.08,613.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M487.68,702.6c-1,1.6-3.2,2.4-5.2,2.4c-0.6,0-1.6-0.4-2.2-0.6l-0.2,0.2c1.2,0.4,2.4,0.8,3.6,0.8 c0.6,0,1,0,1-0.2c2-0.2,3.6-0.6,5.2-1.6l28.8-16.8c3.2-1.8,5.8-5.2,7.4-8.8l-37.6,21.6C488.48,700.6,488.48,701.6,487.68,702.6z"
}), React.createElement("polygon", {
  className: "st0",
  points: "651.28,526.6 653.48,525.4 649.88,523.4  "
}), React.createElement("polygon", {
  className: "st0",
  points: "653.48,525.4 651.28,526.6 653.68,532.6 658.88,529.2 658.68,528.4  "
}), React.createElement("path", {
  className: "st0",
  d: "M617.08,443.6c1.6-0.8,4-1,6,0.2l0.6,0.4l-1.4-3.6L617.08,443.6L617.08,443.6z"
}), React.createElement("polygon", {
  className: "st0",
  points: "650.88,509.8 631.28,462.8 626.28,459.8 626.28,465.4 642.28,504.8  "
}), React.createElement("rect", {
  x: 628.42,
  y: 458.15,
  transform: "matrix(0.5019 -0.8649 0.8649 0.5019 -85.8028 773.3111)",
  className: "st0",
  width: 0.2,
  height: 6
}), React.createElement("polygon", {
  className: "st0",
  points: "646.08,513.8 648.68,521 653.48,518.4  "
}), React.createElement("polygon", {
  className: "st0",
  points: "653.48,518.4 648.68,521 649.88,523.4 653.48,525.4 656.48,523.6 654.68,518.8  "
}), React.createElement("polygon", {
  className: "st0",
  points: "658.68,528.4 656.48,523.6 653.48,525.4  "
}), React.createElement("path", {
  className: "st0",
  d: "M620.08,449l4.6-2.6l-1-2.2l-0.6-0.4c-2-1-4.4-1-6-0.2l2.8,6.8L620.08,449L620.08,449z"
}), React.createElement("polygon", {
  className: "st0",
  points: "624.68,446 620.08,449 627.48,453.4  "
}), React.createElement("polygon", {
  className: "st0",
  points: "622.88,458 626.28,465.4 626.28,459.8  "
}), React.createElement("polygon", {
  className: "st0",
  points: "654.08,517.8 650.88,509.8 642.28,504.8 646.08,513.8 653.48,518.4  "
}), React.createElement("polygon", {
  className: "st0",
  points: "654.68,518.8 654.08,517.8 653.48,518.4  "
}), React.createElement("polygon", {
  className: "st0",
  points: "626.28,459.8 626.28,459.6 631.28,462.4 627.48,453.4 620.08,449 620.08,450.4 622.88,458  "
}), React.createElement("path", {
  className: "st0",
  d: "M578.88,532.2l16.2-9.6l-30.4,17.6l2.6-9.2c4.2-15.6,9-31,12.6-46.4l15.2,38.2l-15.8-40.6 c-1.2-2.8-2-5.4-3-8.2c-7,26.2-14.4,52.8-21.8,79l21.8-12.4c-0.6-1-0.8-2-0.8-3C575.88,535.2,577.08,533,578.88,532.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M499.08,607.4l21.2-72.6c0.6-1.8,2-3.2,3.6-4c1.6-0.6,2.8-0.4,4.2,0l22.4-76.6l-1.6-1c-2-1.4-3.2-4.4-2.6-7 l6.8-24.2L499.08,607.4L499.08,607.4z"
}), React.createElement("polygon", {
  className: "st0",
  points: "591.48,577.4 611.68,565.6 610.08,560.6 608.68,560.2 585.28,573.8  "
}), React.createElement("path", {
  className: "st0",
  d: "M475.88,686.6l18.2-62.2l0,0l-18.4,62.8l0.4,0.2C475.88,687.4,475.88,687.2,475.88,686.6z"
}), React.createElement("rect", {
  x: 497.68,
  y: 607.2,
  className: "st0",
  width: 0,
  height: 9
}), React.createElement("rect", {
  x: 495.28,
  y: 615.6,
  className: "st0",
  width: 0,
  height: 9
}), React.createElement("path", {
  className: "st0",
  d: "M590.48,394l-0.8,0.4l7,4.2l0,0l0.4,0.2c0,0,0,0-0.2,0c1,0.2,1.8,0.8,2.2,1.8l1.2,3.2c1-0.6,2-1.2,2.4-2.4 c1.6-2.8,0.6-6.2-2.6-7.8c-0.2-0.2-0.6-0.4-0.8-0.6l-0.4-0.2C596.28,391.8,593.28,392.4,590.48,394z"
}), React.createElement("polygon", {
  className: "st0",
  points: "510.88,589.2 507.28,602.6 507.28,602.6  "
}), React.createElement("polygon", {
  className: "st0",
  points: "581.68,537.6 603.28,525.2 581.48,537.4  "
}), React.createElement("polygon", {
  className: "st0",
  points: "585.28,480 584.88,479.8 603.28,525.2  "
}), React.createElement("polygon", {
  className: "st0",
  points: "552.28,447.8 552.48,448 559.68,423.6  "
}), React.createElement("path", {
  className: "st0",
  d: "M593.28,399.2c1-0.6,2.2-0.6,3-0.6C595.28,398.6,594.68,398.6,593.28,399.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M488.48,699.6c0-0.8-0.2-1.4-0.4-2.2l-1.4,0.8c-1,0.4-1.6,0.8-2.6,0.8c-0.8,0-1.6-0.2-2.2-0.6v0.2l-7.6-4.4 c0,3,0.6,5.8,2.4,7.6c0.8,1,1.6,1.6,2.8,2.2c0.2,0.2,0.4,0.2,0.8,0.2L488.48,699.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M634.68,608c0.6,1,0.6,1.2,1.6,1.8l-9.6-5.6l2.2,5.8c1,2.4,2.8,4,4.8,5c0.2,0,0.4,0,0.6,0.2l8.2-4.6 c0-0.8,0-1.6-0.4-2.4l-1.8,1C637.68,611,635.48,610.4,634.68,608z"
}), React.createElement("path", {
  className: "st0",
  d: "M502.08,620l-20,68c-0.4,1-0.6,2.2-1,3.6L502.08,620L502.08,620z"
}), React.createElement("polygon", {
  className: "st0",
  points: "579.48,577.2 573.28,580.6 579.48,584.2 585.48,580.6  "
}), React.createElement("path", {
  className: "st0",
  d: "M482.68,705.2c2.2,0,4.2-0.8,5.2-2.4c0.6-1,0.6-2,0.8-3l-8.4,4.8C481.08,704.8,482.08,705.2,482.68,705.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M642.08,613.8c0.6-1,0.4-2,0.6-3l-8.2,4.6C637.28,616.4,640.08,616.4,642.08,613.8z"
}), React.createElement("rect", {
  x: 505.88,
  y: 602.6,
  className: "st0",
  width: 0,
  height: 9
}), React.createElement("rect", {
  x: 503.48,
  y: 611.2,
  className: "st0",
  width: 0,
  height: 9
}), React.createElement("path", {
  className: "st0",
  d: "M553.48,421.8l-6.8,24.2c-0.6,2.8,0.6,5.6,2.6,7l1.6,1l1.8-6.2l-0.2-0.2l7.4-24c0.6-3.4,3.2-6.6,5.8-8.2 l27.8-16.2c1.4-0.6,2.2-0.6,3-0.6c0.2,0,0.4-0.2,0.6-0.2l-7-4.2l-27.6,15.8C557.88,412.4,555.08,417.2,553.48,421.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M581.48,537.4l21.6-12.2l-18.4-45.4c-2.2-5.6-3.6-10.8-5.2-16.4c-1,3.6-2,7-3,10.6c1,2.8,1.8,5.4,3,8.2 l15.8,40.6l-16.2,9.6c-2,1.2-3.2,3.2-3.2,5.4c0,1,0.2,2.2,0.8,3L581.48,537.4L581.48,537.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M510.88,589.2l17.2-58.8c-1.4-0.4-2.8-0.4-4.2,0c-1.6,0.8-3.2,2.2-3.6,4l-21.2,72.6l8.2-4.6L510.88,589.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M597.48,398.6l-0.4-0.2C597.08,398.6,597.28,398.6,597.48,398.6C597.28,398.6,597.48,398.6,597.48,398.6z"
}), React.createElement("polygon", {
  className: "st0",
  points: "585.28,573.8 579.48,577.2 585.48,580.6 591.48,577.4  "
}), React.createElement("path", {
  className: "st0",
  d: "M610.08,560.6l1.8,4.8l0.2-0.2l14.6,39l9.6,5.6c-1-0.6-1-0.8-1.6-1.8l-19.4-51.6l-6.2,3.6L610.08,560.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M482.08,698.6c-1.6-1-2-3.6-1-6.8v-0.2c0.2-1.2,0.6-2.6,1-3.6l20-68l-8,4.6l-18.2,62.2c0,0.4,0,0.6,0,1 l-0.4-0.2l-0.8,2.4c-0.4,1.4-0.2,2.8-0.2,4.2L482.08,698.6C482.08,698.8,482.08,698.6,482.08,698.6z"
}), React.createElement("polygon", {
  className: "st0",
  points: "504.68,611.4 507.28,602.6 499.08,607.4 496.48,616  "
}), React.createElement("polygon", {
  className: "st0",
  points: "496.48,616 494.08,624.8 502.08,620 504.68,611.4  "
}), React.createElement("path", {
  className: "st0",
  d: "M595.88,404.8l-27.2,16.2l26.2-15.2l18.8,46V449c0-2.2,1-4.2,3.2-5.4l0.2-0.2l-16.2-39.6 C599.08,404.8,597.48,405.4,595.88,404.8z"
}), React.createElement("polygon", {
  className: "st0",
  points: "641.08,518.4 643.48,524 647.28,521.8  "
}), React.createElement("polygon", {
  className: "st0",
  points: "594.08,537.6 606.28,530.4 594.08,537.4  "
}), React.createElement("path", {
  className: "st0",
  d: "M582.68,458c1,0.8,2,2,2.4,3.4C584.88,460,583.88,459,582.68,458z"
}), React.createElement("path", {
  className: "st0",
  d: "M568.68,421c-1.2,0.8-2,1.8-2.6,3.2C566.68,422.4,567.68,421.2,568.68,421z"
}), React.createElement("polygon", {
  className: "st0",
  points: "559.68,444.8 559.68,444.8 561.08,440  "
}), React.createElement("path", {
  className: "st0",
  d: "M608.68,522.8l-18.4-45.4c-2-5.2-3.6-10.6-5.2-16c1.6,5.4,3.2,10.6,5.2,16L608.68,522.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M535.48,600.6l-19.8,71c-0.6,2-2,3.8-3.2,4.4l-24.6,14.4l22-75.2l0,0l-22,74.2c-0.6,1.6-1,4.2-1,5 c1,0.8,1.2,1.6,1.4,2.6l27.4-16c2.6-1.6,5.2-5,6.2-8.4l20.4-74.6l30.8-17.8l-1.6-1L535.48,600.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M667.48,582.8L667.48,582.8c0,2-1.6,4.6-3.2,5.6l-25.2,14.6l-18.4-48.8l19.4,51.6c1,0.6,1.4,1.6,1.8,2.6 l25.6-14.8c3.2-2,6.2-6.8,6.2-10.6c0-1-0.6-1.8-0.6-2.6l-19.8-48l-5.4,3.2L667.48,582.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M619.08,552.4c0.6,0.6,1.4,1.2,1.6,2c-0.2-0.8-0.8-1.6-1.4-2.2L619.08,552.4z"
}), React.createElement("polygon", {
  className: "st0",
  points: "651.28,526.6 649.88,523.4 647.28,521.8 643.48,524 645.88,530  "
}), React.createElement("polygon", {
  className: "st0",
  points: "509.68,615.4 509.68,615.4 510.88,611.6  "
}), React.createElement("polygon", {
  className: "st0",
  points: "648.28,535.6 653.68,532.6 651.28,526.6 645.88,530  "
}), React.createElement("path", {
  className: "st0",
  d: "M618.68,551.4c0.2,0.2,0.4,0.4,0.6,0.8l0.2-0.2C619.08,551.8,618.88,551.6,618.68,551.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M539.08,593c-1,0.8-2,2.2-2.6,3.8l-1,3.8l36-20.8l-4.6-2.6L539.08,593z"
}), React.createElement("path", {
  className: "st0",
  d: "M617.08,443.6L617.08,443.6h-0.4H617.08z"
}), React.createElement("path", {
  className: "st0",
  d: "M613.68,449c0-2.2,1.6-4.2,3.2-5.4C614.68,444.8,613.68,446.6,613.68,449z"
}), React.createElement("polygon", {
  className: "st0",
  points: "642.28,504.8 626.28,465.4 625.88,481.6 633.48,499.8  "
}), React.createElement("path", {
  className: "st0",
  d: "M620.08,456l-3.2-1.8c-2.2-1.2-3.2-3.2-3.2-5.4v2.8l6.2,15.4L620.08,456L620.08,456z"
}), React.createElement("polygon", {
  className: "st0",
  points: "648.68,521 646.08,513.8 637.28,509 641.08,518.4 647.28,521.8  "
}), React.createElement("polygon", {
  className: "st0",
  points: "647.28,521.8 649.88,523.4 648.68,521  "
}), React.createElement("path", {
  className: "st0",
  d: "M613.68,449c0,2.2,1,4.2,3.2,5.4l3.2,1.8v-5.8l-2.8-6.8c0,0-0.2,0-0.4,0 C615.08,444.8,613.68,446.6,613.68,449z"
}), React.createElement("polygon", {
  className: "st0",
  points: "642.28,504.8 633.48,499.8 637.28,509 646.08,513.8  "
}), React.createElement("polygon", {
  className: "st0",
  points: "625.88,481.6 626.28,465.4 622.88,458 620.08,456 620.08,466.8  "
}), React.createElement("polygon", {
  className: "st0",
  points: "620.08,450.4 620.08,456 622.88,458  "
}), React.createElement("path", {
  className: "st0",
  d: "M549.08,551.4c0,0.4,0,0.8,0,1.4l9.4,5.4l23.6-13.6l-3-1.8c-1-0.6-1.8-1.4-2.4-2.4l-21.8,12.4 c7.4-26.2,14.6-52.8,21.8-79c-0.8-2.2-1.6-4.2-2.4-6.4l-2.2-1.2c-5,20.4-10.8,41-16.6,61.4L549.08,551.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M529.88,531.2l4,2.2l22.4-76.4l-5.4-3l-22.4,76.6C528.68,531,529.08,531,529.88,531.2z"
}), React.createElement("polygon", {
  className: "st0",
  points: "585.28,573.8 608.68,560.2 607.48,559.2 583.88,572.6  "
}), React.createElement("polygon", {
  className: "st0",
  points: "583.88,572.6 607.48,559.2 602.68,556.4 579.08,570.2  "
}), React.createElement("polygon", {
  className: "st0",
  points: "514.88,598.4 532.08,539.6 526.48,536.4 510.88,589.2 507.28,602.6  "
}), React.createElement("path", {
  className: "st0",
  d: "M596.68,398.6L596.68,398.6C597.08,398.6,597.08,398.6,596.68,398.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M584.88,479.8l0.6,0.4l17.8,45l-21.4,12.2l6.2,3.6l6.2-3.6l0,0l12-6.8c2.6-1.6,3.6-4.8,2.6-7.6l-18.4-45.4 c-2-5.4-3.6-10.6-5.2-16c-0.4-1.4-1.4-2.6-2.4-3.4c-0.8-0.6-1.8-1.2-3.4-1c-2.4,0-4,1.4-5.2,3.2l5.4,3 C581.28,469,582.48,474.2,584.88,479.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M593.28,399.2l-27.8,16.2c-3.2,2-4.8,4.6-5.8,8.2l-7,24.2l5.4,3l1.8-6l0,0l1.4-4.8l4.4-14.8 c0.2-0.4,0.4-0.8,0.6-1.2c0.6-1.4,1.4-2.4,2.6-3.2l27.2-16.2c1.6,0.6,3.4,0,5-1l-1.2-3.2c-0.4-1-1.4-1.4-2.2-1.8 c-0.4-0.2-0.6-0.2-1-0.2C595.08,398.6,594.08,398.6,593.28,399.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M621.08,554.2c-0.4-0.8-1-1.4-1.6-2l-5.6,3.2l1.6,1l19.4,51.6c1,2.4,3.2,2.8,5.8,1.4l1.8-1 c-0.4-1-0.8-2-1.8-2.6L621.08,554.2z"
}), React.createElement("polygon", {
  className: "st0",
  points: "577.68,576.4 571.48,580 573.28,580.6 579.48,577.2  "
}), React.createElement("path", {
  className: "st0",
  d: "M487.68,689.8l22-74.2l-7.6,4.4l-21,71.6c-0.6,2.6-0.8,5.4,0.8,7c0.6,0.4,1.4,0.6,2.2,0.6 c1,0,1.6-0.4,2.6-0.8l1.4-0.8c-0.4-1-0.6-1.8-1.4-2.6C486.68,693.8,487.28,691.4,487.68,689.8z"
}), React.createElement("polygon", {
  className: "st0",
  points: "514.88,598.4 507.28,602.6 504.68,611.4 512.48,606.6  "
}), React.createElement("polygon", {
  className: "st0",
  points: "567.08,577.2 571.48,580 577.68,576.4 573.28,573.6  "
}), React.createElement("polygon", {
  className: "st0",
  points: "512.48,606.6 504.68,611.4 502.28,620 509.68,615.4 510.88,611.6  "
}), React.createElement("path", {
  className: "st0",
  d: "M617.28,550.6c-1.6-0.6-3.6-0.4-5.2,0.4l-3.2,1.8l4.6,2.6l5.6-3.2c-0.2-0.2-0.4-0.6-0.6-0.8 C618.28,551.4,617.68,551,617.28,550.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M526.48,536.4l5.4,3.2l1.8-6.2l-4-2.2c-0.6-0.2-1-0.2-1.6-0.4l-17.2,58.8L526.48,536.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M576.48,474c1-3.6,2-7,3-10.6l-5.2-3c-0.4,0.6-0.8,0.8-1,1.4c-0.4,1.4-0.8,3-1.2,4.4l2.2,1.2 C575.08,469.6,575.88,471.6,576.48,474z"
}), React.createElement("path", {
  className: "st0",
  d: "M597.28,398.6c-0.2,0-0.2-0.2-0.2-0.2l0,0c-0.2,0-0.4,0.2-0.6,0.2C596.48,398.6,596.68,398.6,597.28,398.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M565.28,415.4c-2.6,1.6-5.2,4.8-5.8,8.2C560.48,420,562.28,417.4,565.28,415.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M581.68,537.6l-5.2,3c0.6,1,1.4,1.8,2.4,2.4l3,1.8l6-3.4L581.68,537.6z"
}), React.createElement("polygon", {
  className: "st0",
  points: "557.68,451 552.48,448 550.88,454 556.28,457.2  "
}), React.createElement("path", {
  className: "st0",
  d: "M551.28,557.6c1,0.8,2.6,1.4,3.6,1.4s2-0.2,3.2-0.8l0.4-0.2l-9.4-5.4C548.88,554.4,549.68,556.4,551.28,557.6 z"
}), React.createElement("path", {
  className: "st0",
  d: "M481.08,691.4L481.08,691.4c-1.2,3.4-0.6,5.8,1,7C480.28,696.8,480.48,694,481.08,691.4z"
}), React.createElement("polygon", {
  className: "st0",
  points: "608.68,560.2 615.08,556.4 613.68,555.4 607.48,559.2  "
}), React.createElement("polygon", {
  className: "st0",
  points: "583.88,572.6 577.68,576.4 579.48,577.2 585.28,573.8  "
}), React.createElement("polygon", {
  className: "st0",
  points: "602.68,556.4 607.48,559.2 613.68,555.4 608.88,552.8  "
}), React.createElement("polygon", {
  className: "st0",
  points: "579.08,570.2 573.28,573.6 577.68,576.4 583.88,572.6  "
})));

var SvgWordcloudIcon = function SvgWordcloudIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Livello_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWordcloudIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Wordcloud_Icon.9727e46c.svg";
export { ForwardRef as ReactComponent };